import React, { useState } from "react";
import { useRef } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip"; // The strip
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const AICTEApproval = () => {
  const topRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  // Array reversed to show descending order (Latest to Oldest)
  const pdfList = [
    { id: 26, title: "EOA-2026-27", src: "/pdf/aicete/EOA-2026-2027.PDF", isWeb: false },
    { id: 25, title: "EOA-2025-26", src: "/pdf/aicete/AICTE-Approval-letter.pdf", isWeb: false },
    { id: 24, title: "EOA-2024-25", src: "/pdf/aicete/AICTE-EOA-Report-2024-2025.pdf", isWeb: false },
    { id: 23, title: "EOA-2023-24", src: "/pdf/aicete/EOA-2023-24.pdf", isWeb: false },
    { id: 22, title: "EOA-2022-23", src: "/pdf/aicete/EOA-_Report_2022-23.pdf", isWeb: false },
    { id: 21, title: "EOA-2021-22", src: "/pdf/aicete/EOA-_Report_2021-22.pdf", isWeb: false },
    { id: 20, title: "EOA-2020-21", src: "/pdf/aicete/EOA_Report_2020-21.pdf", isWeb: false },
    { id: 19, title: "EOA-2019-20", src: "/pdf/aicete/EOA-_Report_2019-20.pdf", isWeb: false },
    { id: 18, title: "EOA-2018-19", src: "/pdf/aicete/EOA-_Report_2018-19.pdf", isWeb: false },
    { id: 17, title: "EOA-2017-18", src: "/pdf/aicete/EOA_Report_2017-18.pdf", isWeb: false },
    { id: 16, title: "EOA-2016-17", src: "/pdf/aicete/EOA_Report_2016-17.pdf", isWeb: false },
    { id: 15, title: "EOA-2015-16", src: "/pdf/aicete/EOA-_Report_-2015-16.pdf", isWeb: false },
    { id: 14, title: "EOA-2014-15", src: "/pdf/aicete/EOA_Report_2014-15.pdf", isWeb: false },
    { id: 13, title: "EOA-2013-14", src: "/pdf/aicete/EOA_Report_2013-14.pdf", isWeb: false },
    { id: 12, title: "EOA-2012-13", src: "/pdf/aicete/EOA_Report_2012-13.pdf", isWeb: false },
    { id: 11, title: "EOA-2011-12", src: "/pdf/aicete/EOA_Report_2011-12.pdf", isWeb: false },
    { id: 10, title: "EOA-2010-11", src: "/pdf/aicete/EOA_Report_2010-11.pdf", isWeb: false },
    { id: 9, title: "EOA-2009-10", src: "/pdf/aicete/EOA_Report_2009-10.pdf", isWeb: false },
    { id: 8, title: "EOA-2008-09", src: "/pdf/aicete/EOA_Report_2008-09.pdf", isWeb: false },
    { id: 7, title: "EOA-2007-08", src: "/pdf/aicete/EOA_Report_2007-08.pdf", isWeb: false },
    { id: 6, title: "EOA-2006-07", src: "/pdf/aicete/EOA_Report_2006-07.pdf", isWeb: false },
    { id: 5, title: "EOA-2005-06", src: "/pdf/aicete/EOA_Report_2005-06.pdf", isWeb: false },
    { id: 4, title: "EOA-2004-05", src: "/pdf/aicete/EOA_Report_2004-05.pdf", isWeb: false },
    { id: 3, title: "EOA-2003-04", src: "/pdf/aicete/EOA_Report_2003-04.pdf", isWeb: false },
    { id: 2, title: "EOA-2002-03", src: "/pdf/aicete/EOA_Report_2002-03.pdf", isWeb: false },
    { id: 1, title: "EOA-2001-02", src: "/pdf/aicete/EOA_Report_2001-02.pdf", isWeb: false },
  ];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }

    setMobileOpen(false); // Close drawer on mobile after selection
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader
            title="AICTE Approval" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'AICTE Approval' }]} 
          />
        </div>
{showForm && <BrochureForm setShowForm={setShowForm} />}
        <div className="spv-main-content">
          <>
            <div 
              className={`spv-mobile-overlay ${mobileOpen ? "active" : ""}`}
              onClick={() => setMobileOpen(false)}
            />

            <aside className={`spv-sidebar-modern ${mobileOpen ? "mobile-open" : ""}`}>
              {/* Added topbar wrapper for the header text and close button */}
              <div className="spv-sidebar-topbar">
                <div className="spv-sidebar-header-text">POLICY DOCUMENTS</div>
                <button 
                  className="spv-mobile-close" 
                  onClick={() => setMobileOpen(false)}
                  aria-label="Close menu"
                >
                  &times;
                </button>
              </div>

              <nav className="spv-nav-group">
                {pdfList.map((pdf) => (
                  <button
                    key={pdf.id}
                    className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                    onClick={() => handlePdfSelection(pdf)}
                  >
                    <div className="spv-card-content">
                      <img 
                        src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                        alt="icon" 
                        className="spv-doc-icon-img" 
                      />
                      <span className="spv-card-text">{pdf.title}</span>
                      <img 
                        src="/images/icons/move.webp" 
                        alt="arrow icon" 
                        className="spv-doc-icon-img" 
                      />
                    </div>
                  </button>
                ))}
              </nav>
            </aside>
          </>

          <main className="spv-viewer-area" key={activePdf.id}>
            <header className="spv-viewer-topbar">
              <div style={{ display: "flex", alignItems: "center" }}>
                
                {/* Mobile Toggle Button - Hidden on desktop via CSS */}
                <button 
                  className="spv-btn spv-btn-outline spv-mobile-toggle-inline" 
                  onClick={() => setMobileOpen(true)}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}>
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                  </svg>
                  Docs
                </button>

                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>

              <div className="spv-action-group">
                <button 
                  className="spv-btn spv-btn-outline" 
                  onClick={() => window.open(activePdf.src)}
                >
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Institutional Policy"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
          
        </div>
              <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />

      </div>
      <Footer />
    </>
  );
};

export default AICTEApproval;